import { Box, Link, SxProps, Theme, Typography, useTheme } from '@mui/material';
import React, { useState } from 'react';
import MarkdownContainer from './MarkdownContainer';

interface CollapsibleTextProps {
  text: string;
  limit?: number;
  textStyle?: SxProps<Theme>;
  seeMoreStyle?: SxProps<Theme>;
  isMarkdownText?: boolean;
}

const CollapsibleText: React.FC<CollapsibleTextProps> = ({
  text,
  limit = 140,
  textStyle,
  seeMoreStyle,
  isMarkdownText = false,
}) => {
  const theme = useTheme();
  const [isExpanded, setIsExpanded] = useState(false);


  const renderContent = () => {
    if (isExpanded) {
      return isMarkdownText ? <MarkdownContainer content={text} /> : text;
    }

    const truncatedText = `${text.slice(0, limit)}${text.length > limit ? '...' : ''
      }`;
    return isMarkdownText ? (
      <MarkdownContainer content={truncatedText} />
    ) : (
      truncatedText
    );
  };

  return (
    <Box>
      <Typography sx={{
        fontSize: '13px',
        lineHeight: 'normal',
        fontWeight: "400",
        fontFamily: theme.typography.fontFamily,
        ...textStyle
      }} component="span">
        {renderContent()}
      </Typography>
      {text?.length > limit && (
        <Link
          component="button"
          // variant="body2"
          onClick={() => setIsExpanded(!isExpanded)}
          sx={{
            textAlign: 'right',
            textDecoration: 'underline',
            cursor: 'pointer',
            fontSize: 15,
            fontWeight: '600',
            width: '100%',
            marginTop: -2,
            fontFamily: theme.typography.fontFamily,
            ...seeMoreStyle,
          }}
        >
          {isExpanded ? 'See Less' : 'See More'}
        </Link>
      )}
    </Box>
  );
};

export default CollapsibleText;
